import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCurrencyPipe } from './custom-currency.pipe';

@NgModule({
  declarations: [CustomCurrencyPipe], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [CustomCurrencyPipe], // ✅ Export the pipe for use in other modules
})
export class CurrencyPipeModule {}
